import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChefHat, RefreshCw } from 'lucide-react';

const PageHeader = ({ refetch, isLoading }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
      <div>
        <h1 className="text-3xl font-bold text-gray-900 flex items-center gap-2">
          <ChefHat className="text-orange-500" />
          {t('customerMeals.title', 'Customer Meals')}
        </h1>
        <p className="text-gray-600 mt-1">
          {t('customerMeals.subtitle', 'Manage daily meal preparation and delivery schedules')}
        </p>
      </div>

      <div className="flex items-center gap-3">
        <button
          onClick={() => refetch()}
          disabled={isLoading}
          className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 transition-colors"
        >
          <RefreshCw className={`w-4 h-4 ${isLoading ? 'animate-spin' : ''}`} />
          {t('refresh', 'Refresh')}
        </button>
      </div>
    </div>
  );
};

export default PageHeader;
